import { SkeletonLight } from '@/components/skeleton/skeleton.light';
import { type DefaultHouseHoldProps } from '../-model/props';
import { Button, If, ListItem, useI18n } from '@nosinovacao/nosid-mfe-common';
import { Loader } from '@nosinovacao/fe-icons';

export function DefaultHouseHoldLight({
  loading,
  services,
  selectServiceAccount,
  selectedServiceAccount,
  updateHouseHoldLoading,
  submit,
}: Readonly<DefaultHouseHoldProps>) {
  const { t } = useI18n();
  return (
    <div className="flex size-full flex-col gap-3">
      <SkeletonLight loading={loading} className="h-28 w-full rounded" count={3}>
        <div className="grid gap-3">
          {services.map((service) => {
            const serviceSelected = selectedServiceAccount
              ? service.Id === selectedServiceAccount
              : service.IsDefault;
            return (
              <ListItem
                data-selected={serviceSelected}
                className="focus-visible:border-transparent focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-nos-green data-[pressing=true]:border-transparent data-[selected=true]:border-transparent data-[pressing=true]:outline data-[selected=true]:outline data-[pressing=true]:outline-2 data-[selected=true]:outline-2 data-[pressing=true]:-outline-offset-1 data-[selected=true]:-outline-offset-1 data-[pressing=true]:outline-nos-green data-[selected=true]:outline-nos-green"
                skin="light"
                key={service.Id}
                title={service.Address || t('Services.MainAddress.AddressFallback')}
                subtitle={service.Id}
                trailingIcon={<></>}
                type="button"
                onClick={() => selectServiceAccount(service.Id)}
                data-tid="button-select-service"
              />
            );
          })}
        </div>
      </SkeletonLight>
      <div className="mt-auto max-tablet:pb-8">
        <Button
          skin="light"
          type="button"
          className="w-full tablet:w-fit"
          disabled={!selectedServiceAccount || updateHouseHoldLoading}
          onClick={submit}
          data-tid="button-submit-default-household"
        >
          <If condition={updateHouseHoldLoading} otherwise={t('Services.MainAddress.Submit')}>
            <Loader width={24} height={24} />
          </If>
        </Button>
      </div>
    </div>
  );
}
